module.exports = __webpack_public_path__ + "static/media/shopify11.ac4e0ed0.png";